type IconProps = {
  color?: string;
  size?: number;
  className?: string;
};

export function SendIcon({
  color = "currentColor",
  size = 20,
  className,
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.1701 11.6323C9.1701 11.4747 8.97171 11.4051 8.87329 11.5282L8.12989 12.4574C7.47016 13.2821 6.36341 13.6032 5.36474 13.2598L1.89076 12.0652C1.78256 12.028 1.6699 12.1084 1.6699 12.2228V15.6185C1.6699 16.6409 2.3472 17.5396 3.33005 17.8214L9.16339 19.4936C9.16675 19.4946 9.1701 19.4921 9.1701 19.4886V11.6323Z"
        fill={color}
      />
      <path
        d="M10.4201 19.4889C10.4201 19.4921 10.4232 19.4945 10.4264 19.4936L16.2597 17.8214C17.2426 17.5396 17.9199 16.6409 17.9199 15.6185V12.2229C17.9199 12.1085 17.8072 12.0281 17.699 12.0653L14.2255 13.2598C13.2268 13.6032 12.12 13.2821 11.4603 12.4574L10.7169 11.5281C10.6185 11.4051 10.4201 11.4747 10.4201 11.6323V19.4889Z"
        fill={color}
      />
      <path
        d="M18.2833 6.20507C18.1687 5.94601 17.8941 5.79645 17.6143 5.84063L9.82759 7.07011C9.80606 7.07351 9.78413 7.07351 9.76261 7.07011L1.9759 5.84063C1.69607 5.79645 1.42152 5.94601 1.30688 6.20507L0.107361 8.91585C-0.189015 9.58563 0.151356 10.3656 0.843964 10.6037L5.70347 12.2748C6.28602 12.4751 6.93163 12.2878 7.31647 11.8068L9.63242 8.91181C9.71582 8.80756 9.87438 8.80756 9.95778 8.91181L12.2737 11.8068C12.6586 12.2878 13.3042 12.4751 13.8867 12.2748L18.7462 10.6037C19.4388 10.3656 19.7792 9.58563 19.4828 8.91585L18.2833 6.20507Z"
        fill={color}
      />
      <path
        d="M12.737 3.56696C12.9811 3.32288 12.9811 2.92715 12.737 2.68308L10.237 0.183058C9.99295 -0.0610193 9.59722 -0.0610193 9.35315 0.183058L6.85313 2.68308C6.60905 2.92715 6.60905 3.32288 6.85313 3.56696C7.09721 3.81104 7.49293 3.81104 7.73701 3.56696L8.81445 2.48952C8.94569 2.35828 9.1701 2.45123 9.1701 2.63683V5.62502C9.1701 5.9702 9.44992 6.25002 9.7951 6.25002C10.1403 6.25002 10.4201 5.9702 10.4201 5.62502V2.63686C10.4201 2.45125 10.6445 2.3583 10.7757 2.48954L11.8532 3.56696C12.0972 3.81104 12.493 3.81104 12.737 3.56696Z"
        fill={color}
      />
    </svg>
  );
}
